<template>
  <div class="container container-shadow login-container forgot-password-container">
      <el-form :model="formVal" :rules="formRules" ref="formVal" class="login-box" @submit.native.prevent>
        <h2>Forgot your password?</h2>
        <p class="forgot-password-tips">We can send you an email to help you get back into your account.</p>
        <div class="send-tips" v-show="isSend">
          <i class="el-icon-close" @click="isSend=false"></i>
          <p>A password reset email was just sent to you.</p>
          <p>The reset link will expire after 48 hours.</p>
        </div>
        <el-form-item prop="email" class="form-row">
            <el-input v-model="formVal.email" placeholder="Email" auto-complete="off"></el-input>
        </el-form-item>
        <div class="form-row form-button">
          <el-button @click="submitForm('formVal')" :loading="isLoading">Send  Email</el-button>
          <router-link :to="{name:'login'}" class="btn-cancel">Cancel</router-link>
        </div> 
      </el-form>
  </div>
</template>

<script>
import { validatePass, validateEmailNeedExist } from 'utils/validate'
import { requestPasswordReset } from 'service/login'
export default {
  data() {
    return {
      isLoading: false,
      isSend: false,
      formVal: {
        email: ''
      },
      formRules: {
        email: [
          { required: true, message: 'Required.', trigger: 'blur' },
          {
            type: 'email',
            message: 'Invalid email format.',
            trigger: ['blur']
          },
          { validator: validateEmailNeedExist, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    window.vuex_store.commit('set_title', 'Account Settings')
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log('valid', valid)
        if (valid) {
          this.isLoading = true
          requestPasswordReset({ email: this.formVal.email })
            .then(() => {
              this.isSend = true
              this.isLoading = false
            })
            .catch(() => {
              this.isLoading = false
            })
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.forgot-password-container {
  height: 448px;
  h2 {
    font-size: 30px;
    line-height: 30px;
    color: #333333;
    line-height: 1;
    text-align: center;
  }
  .forgot-password-tips {
    line-height: 1;
    color: #333333;
    text-align: center;
    margin-top: 8px;
  }
  .form-row {
    margin-top: 30px;
  }
  .btn-cancel {
    display: block;
    width: 100px;
    margin: 0 auto;
    font-size: 16px;
    line-height: 30px;
    color: #666666;
    text-align: center;
    margin-top: 13px;
    &:hover {
      color: $color-primary;
      text-decoration: underline;
    }
  }
  .send-tips {
    position: relative;
    height: 70px;
    margin-top: 30px;
    margin-bottom: -20px;
    background-color: #f2f2f2;
    font-size: 14px;
    line-height: 24px;
    color: #0A95FF;
    padding: 10px 0 0 23px;
    i {
      position: absolute;
      right: 9px;
      top: 9px;
      color: #999;
    }
  }
}
</style>
